import Vue from 'vue'
import App from './App.vue'
import router from './router'
// eslint-disable-next-line
import filter from './filters'
import { store } from './store/store'
import th from 'vee-validate/dist/locale/th'
import { Validator } from 'vee-validate'
import VeeValidate from 'vee-validate'
// eslint-disable-next-lines
import config from '@/config'
import ReadMore from 'vue-read-more'

import MainLayout from './components/layout/MainLayout.vue'

import * as VueGoogleMaps from 'vue2-google-maps'
import VueTruncate from 'vue-truncate-filter'
import VueProgressiveImage from 'vue-progressive-image'
import mainMixin from '@/mixins/mainMixin'
import i18n from './lang/lang'
import FlagIcon from 'vue-flag-icon'
import Vuetify from 'vuetify'
import dict from './assets/js/CustomError'
import { bearhousecalculateshippingprice } from './assets/js/BearHouse.js'

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/src/sweetalert2.scss'
const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}

import VueLodash from 'vue-lodash'
import lodash from 'lodash'

import LoadScript from 'vue-plugin-load-script'

Vue.use(VueGoogleMaps)

Vue.prototype.$liff = window.liff

Validator.extend('isBearhousezipcode', (value, otherValue) => {
  var amount = otherValue[0]
  var active = otherValue[1]

  if (active) {
    var zipcode = ''
    if (value && value.match(/([1-9][0-9]{4})|^([1-9][0-9]{4})/g)) {
      zipcode = value.match(/([^0-9][1-9][0-9]{4})|^([1-9][0-9]{4})/g)[0].trim()
    }
    return bearhousecalculateshippingprice(zipcode, amount, null, null)
  } else {
    return true
  }
})

Validator.extend('hasPostcode', (value) => {
  var zipcode = ''
  if (value && value.match(/([1-9][0-9]{4})|^([1-9][0-9]{4})/g)) {
    zipcode = value.match(/([^0-9][1-9][0-9]{4})|^([1-9][0-9]{4})/g)[0].trim()
  }
  return zipcode ? true : false
})

Validator.extend('isEmail', (value) => {
  if (value && /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
    return true
  } else {
    return false
  }
})

Vue.use(LoadScript)

Vue.use(VueSweetalert2, options)

import '@mdi/font/css/materialdesignicons.css'
Vue.use(Vuetify, {
  iconfont: 'mdi'
})
import 'vuetify/dist/vuetify.min.css'

import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective)

Vue.use(FlagIcon)

Vue.config.productionTip = false

Vue.use(VueProgressiveImage, {
  // cache: false
})
Vue.use(VueTruncate)

Validator.localize({ th: th })
Validator.localize('en', dict.en)
Validator.localize('th', dict.th)

Vue.use(VeeValidate, { locale: 'th' })
Vue.use(ReadMore)

Vue.mixin(mainMixin)
Vue.component('v-main-layout', MainLayout)

export var app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
